import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormConfig, IFormConfig } from '@app/infrastructure/models/form/form';

import { IStudentClassListItemDTO } from '@models/student-classroom';
import { ITeacherClassListItemDTO } from '@models/teacher-classroom';

@Component({
  selector: 'app-shared-classroom-list-presentation',
  templateUrl: './classroom-list-presentation.component.html',
  styleUrls: ['./classroom-list-presentation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassroomListPresentationComponent {
  @Input() public classroomList:
    | IStudentClassListItemDTO[]
    | ITeacherClassListItemDTO[];
  @Input() headerText: string = '';
  @Input() subtitle?: string;
  @Input() classroomCode?: IFormConfig;

  @Output() public emitForm = new EventEmitter<UntypedFormGroup>();
  @Output() public emitSubmit = new EventEmitter<void>();

  public propagateForm(form: UntypedFormGroup): void {
    this.emitForm.emit(form);
  }

  public submit(): void {
    this.emitSubmit.emit();
  }
}
